import ajax from '../utils/request';

const signinApi = {
  // 新增奖品
  addSignin(params) {
    return ajax({
      url: '/task/prize',
      type: 'post',
      params: params
    });
  },
  // 修改奖品
  editSignin(params) {
    return ajax({
      url: '/task/prize',
      type: 'put',
      params: params
    }, true);
  },
  // 查询奖品
  querySignin(params) {
    return ajax({
      url: '/task/prize',
      type: 'get',
      params: params
    });
  },

  // 查询奖品--配置页面
  queryPrizeBox(params) {
    return ajax({
      url: '/activity/prize/box',
      type: 'get',
      params: params
    });
  },
  // 新增配置
  addSigninConfig(params) {
    return ajax({
      url: '/task/config',
      type: 'post',
      params: params
    });
  },
  // 修改配置
  editSigninConfig(params) {
    return ajax({
      url: '/task/config',
      type: 'put',
      params: params
    });
  },
  // 查询配置
  querySigninConfig(params) {
    return ajax({
      url: '/task/config',
      type: 'get',
      params: params
    });
  },
}

export default signinApi;